import { render, staticRenderFns } from "./PlatformLogo.vue?vue&type=template&id=82c7be04&scoped=true&"
import script from "./PlatformLogo.vue?vue&type=script&lang=js&"
export * from "./PlatformLogo.vue?vue&type=script&lang=js&"
import style0 from "./PlatformLogo.vue?vue&type=style&index=0&id=82c7be04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c7be04",
  null
  
)

export default component.exports